import { SharedTftSalesCalls } from "@app/shared";

const TftSalesHistories = () => {
  return <SharedTftSalesCalls />;
};

export default TftSalesHistories;
